import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  return (
    <header className="landing-header">
      <div className="header-container">
        <div className="header-content">
          <Link to="/" className="logo-link">
            {/* <img src="/brain_logo_white_final.svg" alt="Neural Network Visualizer" className="logo-img" /> */}
            <span className="logo-text">MLblocks</span>
          </Link>
          <nav className="header-nav">
            <ul className="header-nav-list">
              <li>
                <Link to="/signin" className="nav-button nav-button-secondary">
                  Sign In
                </Link>
              </li>
              <li>
                <Link to="/signup" className="nav-button nav-button-register">
                  Register
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;

